import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import toast from 'react-hot-toast'
import { apiInstance, apiState, ApiStates, getStateByStatus } from '../../Api'
import { Evento, Projeto, RelatorioParcial, AvaliacaoOD, AvaliacaoEJC, AvaliacaoRelatorioFinal, RelatorioFinal, TemaProjeto, ParametroProjeto } from '../../Domain/Shared'

interface IAlunoState {
  evento?: Evento[]
  projeto?: Projeto
  parametroProjeto?: ParametroProjeto[]
  temaProjeto?: TemaProjeto[]
  apiStates: ApiStates<typeof customActions>
  relatorioParcial?: RelatorioParcial
  relatorioFinal?: RelatorioFinal
  avaliacaoRelatorioFinal?: AvaliacaoRelatorioFinal[]
  avaliacaoOficinaDebate?: AvaliacaoOD[] | null
  avaliacaoEncontroJuridico?: AvaliacaoEJC[] | null
}

let initialState: IAlunoState = {
  apiStates: {},
}

const alunoSlicer = createSlice({
  name: 'alunoSlicer',
  initialState,
  reducers: {
    setApiState: (state, action: PayloadAction<ApiStates<typeof customActions>>) => {
      state.apiStates = { ...state.apiStates, ...action.payload }
    },
    setProjeto: (state, action: PayloadAction<Projeto>) => {
      state.projeto = action.payload
    },
    setTemaProjeto: (state, action: PayloadAction<TemaProjeto[]>) => {
      state.temaProjeto = action.payload
    },
    setParametroProjeto: (state, action: PayloadAction<ParametroProjeto[]>) => {
      state.parametroProjeto = action.payload
    },
    setEvento: (state, action: PayloadAction<Evento[]>) => {
      state.evento = action.payload
    },
    setRelatorioParcial: (state, action: PayloadAction<RelatorioParcial>) => {
      state.relatorioParcial = action.payload
    },
    setRelatorioFinal: (state, action: PayloadAction<RelatorioFinal>) => {
      state.relatorioFinal = action.payload
    },
    setAvaliacaoRelatorioFinal: (state, action: PayloadAction<AvaliacaoRelatorioFinal[]>) => {
      state.avaliacaoRelatorioFinal = action.payload
    },
    setAvaliacaoOficinaDebate: (state, action: PayloadAction<AvaliacaoOD[]>) => {
      state.avaliacaoOficinaDebate = action.payload
    },
    setAvaliacaoEncontroJuridico: (state, action: PayloadAction<AvaliacaoEJC[]>) => {
      state.avaliacaoEncontroJuridico = action.payload
    },
  },
})

const customActions = {
  encontrosJuridicosAction: () => {
    return async (dispatch: any) => {
      try {
        dispatch(alunoSlicer.actions.setApiState({encontrosJuridicosAction: { state: apiState.loading } }))
        let result
          result = await apiInstance.get<AvaliacaoEJC[]>('aluno/encontrojuridicocientifico')
        dispatch(alunoSlicer.actions.setAvaliacaoEncontroJuridico(result.data))

        dispatch(
          alunoSlicer.actions.setApiState({encontrosJuridicosAction: { state: getStateByStatus(result.status) } })
        )
      } catch (error) {
        dispatch(alunoSlicer.actions.setApiState({encontrosJuridicosAction: { state: apiState.error, error: error } }))
      }
    }
  },
  oficinasDebateAction: () => {
    return async (dispatch: any) => {
      try {
        dispatch(alunoSlicer.actions.setApiState({ oficinasDebateAction: { state: apiState.loading } }))
        let result
          result = await apiInstance.get<AvaliacaoOD[]>('aluno/oficinasdedebates')
        dispatch(alunoSlicer.actions.setAvaliacaoOficinaDebate(result.data))

        dispatch(
          alunoSlicer.actions.setApiState({ oficinasDebateAction: { state: getStateByStatus(result.status) } })
        )
      } catch (error) {
        dispatch(alunoSlicer.actions.setApiState({ oficinasDebateAction: { state: apiState.error, error: error } }))
      }
    }
  },
  alunoEnviarRelatorioParcialAction: (relatorioparcial?: any) => {
    return async (dispatch: any) => {
      try {
        dispatch(alunoSlicer.actions.setApiState({ alunoEnviarRelatorioParcialAction: { state: apiState.loading } }))

        const result = await apiInstance.post('aluno/relatorioparcial', relatorioparcial)
        dispatch(alunoSlicer.actions.setApiState({ alunoEnviarRelatorioParcialAction: { state: getStateByStatus(result.status) } }))
      } catch (error) {
        dispatch(alunoSlicer.actions.setApiState({ alunoEnviarRelatorioParcialAction: { state: apiState.error, error: error } }))
        console.log(error)
      }
    }
  },
  alunoEnviarRelatorioFinalAction: (relatoriofinal?: any, anexo?: string) => {
    const info = {
      titulo: relatoriofinal.titulo,
      sumario: relatoriofinal.sumario,
      resumo: relatoriofinal.resumo,
      palavrasChave: relatoriofinal.palavrasChave,
      introducao: relatoriofinal.introducao,
      desenvolvimento: relatoriofinal.desenvolvimento,
      conclusao: relatoriofinal.conclusao,
      referencias: relatoriofinal.referencias,
      anexos: anexo
    }
    return async (dispatch: any) => {
      try {
        dispatch(alunoSlicer.actions.setApiState({ alunoEnviarRelatorioFinalAction: { state: apiState.loading } }))

        const result = await apiInstance.post('aluno/relatoriofinal', info)
        dispatch(alunoSlicer.actions.setApiState({ alunoEnviarRelatorioFinalAction: { state: getStateByStatus(result.status) } }))
      } catch (error) {
        dispatch(alunoSlicer.actions.setApiState({ alunoEnviarRelatorioFinalAction: { state: apiState.error, error: error } }))
        console.log(error)
      }
    }
  },
  alunoSolicitarOrientacaoAction: (orientacao?: any) => {
    const info = {
      dataSugeridaAluno: new Date(`${orientacao?.dataSugeridaAluno}, ${orientacao?.hora}`),
      local: orientacao?.local,
    }
    return async (dispatch: any) => {
      try {
        dispatch(alunoSlicer.actions.setApiState({ alunoSolicitarOrientacaoAction: { state: apiState.loading } }))

        const result = await apiInstance.post('aluno/orientacao', info)
        dispatch(
          alunoSlicer.actions.setApiState({
            alunoSolicitarOrientacaoAction: { state: getStateByStatus(result.status) },
          })
        )
      } catch (error) {
        dispatch(
          alunoSlicer.actions.setApiState({ alunoSolicitarOrientacaoAction: { state: apiState.error, error: error } })
        )
        console.log(error)
      }
    }
  },
  relatorioParcialAction: () => {
    return async (dispatch: any) => {
      try {
        dispatch(alunoSlicer.actions.setApiState({ relatorioParcialAction: { state: apiState.loading } }))

        const result = await apiInstance.get<RelatorioParcial>('aluno/relatorioparcial')

        dispatch(alunoSlicer.actions.setRelatorioParcial(result.data))

        dispatch(alunoSlicer.actions.setApiState({ relatorioParcialAction: { state: getStateByStatus(result.status) } }))
      } catch (error) {
        dispatch(alunoSlicer.actions.setApiState({ relatorioParcialAction: { state: apiState.error, error: error } }))
      }
    }
  },
  relatorioFinalAction: () => {
    return async (dispatch: any) => {
      try {
        dispatch(alunoSlicer.actions.setApiState({ relatorioFinalAction: { state: apiState.loading } }))

        const result = await apiInstance.get<RelatorioFinal>('aluno/relatoriofinal')

        dispatch(alunoSlicer.actions.setRelatorioFinal(result.data))

        dispatch(alunoSlicer.actions.setApiState({ relatorioFinalAction: { state: getStateByStatus(result.status) } }))
      } catch (error) {
        dispatch(alunoSlicer.actions.setApiState({ relatorioFinalAction: { state: apiState.error, error: error } }))
      }
    }
  },
  avaliacoesRelatorioFinalAction: () => {
    return async (dispatch: any) => {
      try {
        dispatch(alunoSlicer.actions.setApiState({ avaliacoesRelatorioFinalAction: { state: apiState.loading } }))

        const result = await apiInstance.get<AvaliacaoRelatorioFinal[]>('aluno/relatoriofinal/avaliacoes')

        dispatch(alunoSlicer.actions.setAvaliacaoRelatorioFinal(result.data))

        dispatch(alunoSlicer.actions.setApiState({ avaliacoesRelatorioFinalAction: { state: getStateByStatus(result.status) } }))
      } catch (error) {
        dispatch(alunoSlicer.actions.setApiState({ avaliacoesRelatorioFinalAction: { state: apiState.error, error: error } }))
      }
    }
  },
  temaProjetoAction: () => {
    return async (dispatch: any) => {
      try {
        dispatch(alunoSlicer.actions.setApiState({ temaProjetoAction: { state: apiState.loading } }))

        const result = await apiInstance.get<TemaProjeto[]>('aluno/projeto/temas')

        dispatch(alunoSlicer.actions.setTemaProjeto(result.data))

        dispatch(alunoSlicer.actions.setApiState({ temaProjetoAction: { state: getStateByStatus(result.status) } }))
      } catch (error) {
        dispatch(alunoSlicer.actions.setApiState({ temaProjetoAction: { state: apiState.error, error: error } }))
      }
    }
  },
  projetoAction: () => {
    return async (dispatch: any) => {
      try {
        dispatch(alunoSlicer.actions.setApiState({ projetoAction: { state: apiState.loading } }))

        const result = await apiInstance.get('aluno/projeto')

        dispatch(alunoSlicer.actions.setProjeto(result.data))

        dispatch(alunoSlicer.actions.setApiState({ projetoAction: { state: getStateByStatus(result.status) } }))
      } catch (error) {
        dispatch(alunoSlicer.actions.setApiState({ projetoAction: { state: apiState.error, error: error } }))
      }
    }
  },
  parametroProjetoAction: () => {
    return async (dispatch: any) => {
      try {
        dispatch(alunoSlicer.actions.setApiState({ parametroProjetoAction: { state: apiState.loading } }))

        const result = await apiInstance.get<ParametroProjeto[]>('projeto')

        dispatch(alunoSlicer.actions.setParametroProjeto(result.data))

        dispatch(alunoSlicer.actions.setApiState({ parametroProjetoAction: { state: getStateByStatus(result.status) } }))
      } catch (error) {
        dispatch(alunoSlicer.actions.setApiState({ parametroProjetoAction: { state: apiState.error, error: error } }))
      }
    }
  },
  enviarProjetoAction: (projeto: any, matriculaAluno2: string | null | undefined) => {
    const data = 
    {
      matriculaAluno2: matriculaAluno2 ? matriculaAluno2 : null,
      temaId: projeto.temaId,
      tituloProjetoTematico: projeto.tituloProjetoTematico,
      tituloProjeto: projeto.tituloProjeto,
      objetivos: projeto.objetivos,
      objetivosGerais: projeto.objetivosGerais,
      objetivosEspecificos: projeto.objetivosEspecificos,
      contextualizacao: projeto.contextualizacao,
      delimitacaoTema: projeto.delimitacaoTema,
      problematizacao: projeto.problematizacao,
      referenciaBibliografica: projeto.referenciaBibliografica,
      metodo: projeto.metodo,
      justificativa: projeto.justificativa,
      professorId: projeto.professorId,
      cronogramaDescricao: projeto.cronogramaDescricao,
      implicacoesEticas: projeto.implicacoesEticas,
    }

    return async (dispatch: any) => {
      try {
        dispatch(alunoSlicer.actions.setApiState({ enviarProjetoAction: { state: apiState.loading } }))

        const result = await apiInstance.post('aluno/projeto', data)

        dispatch(alunoSlicer.actions.setProjeto(result.data))

        dispatch(alunoSlicer.actions.setApiState({ enviarProjetoAction: { state: getStateByStatus(result.status) } }))
        window.location.reload()
      } catch (error) {
        toast.error(error.response.data[0].message)
        dispatch(alunoSlicer.actions.setApiState({ enviarProjetoAction: { state: apiState.error, error: error } }))
      }
    }
  },  
  eventoAction: () => {
    return async (dispatch: any) => {
      try {
        dispatch(alunoSlicer.actions.setApiState({ eventoAction: { state: apiState.loading } }))

        const result = await apiInstance.get<Evento[]>('eventos')

        dispatch(alunoSlicer.actions.setEvento(result.data))

        dispatch(alunoSlicer.actions.setApiState({ eventoAction: { state: getStateByStatus(result.status) } }))
      } catch (error) {
        dispatch(alunoSlicer.actions.setApiState({ eventoAction: { state: apiState.error, error: error } }))
      }
    }
  },
}

const AlunoReducer = alunoSlicer.reducer
const AlunoActions = { ...customActions }

export { AlunoReducer, AlunoActions }
